import React from "react";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../../lib/data";

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 md:py-32 bg-[#0a0a0a] border-y border-white/5"
    >
      <div className="mx-auto max-w-[1500px] px-6 md:px-12 lg:px-24">
        <div className="grid lg:grid-cols-12 gap-12 mb-16 items-end">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-gold"></span>
              <span className="text-[11px] uppercase tracking-[0.32em] text-white/60">
                Client Voices
              </span>
            </div>
            <h2 className="font-display text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight">
              Trusted by Manchester's most
              <em className="gold-text-gradient not-italic"> discerning</em> founders.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-white/55 leading-relaxed">
              We measure success in two currencies: the revenue we add to your business
              and the words you choose when you describe the work.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <article
              key={t.name}
              data-testid={`testimonial-${i}`}
              className="relative glass p-10 hover:border-gold/30 transition-colors duration-500"
            >
              <Quote className="text-gold/60 mb-6" size={28} strokeWidth={1.2} />
              <p className="font-display italic text-white/90 text-xl md:text-2xl leading-snug">
                "{t.quote}"
              </p>
              <div className="mt-8 pt-6 border-t border-white/10 flex items-center gap-4">
                <div className="h-12 w-12 rounded-full gold-bg-gradient flex items-center justify-center text-black font-bold">
                  {t.initials}
                </div>
                <div>
                  <div className="text-white">{t.name}</div>
                  <div className="text-xs text-white/50 mt-0.5">
                    {t.role} · {t.location}
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
